import { makeStyles } from "@material-ui/core/styles";
import colors from "Styles/colors";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    fontSize: 14,
    color: colors.black,
    paddingLeft: 12,
    paddingRight: 0,
    display: "flex",
    alignItems: "center",
    width: 250,
    height: 38,
    border: `1px solid ${palette.grey[300]}`,
    borderRadius: 4,
  },
  button: {
    padding: 10,
    margin: 0,
    minWidth: 20,
    border: "none",
  },
  input: {
    color: colors.black,
    padding: 0,
    fontSize: 14,
    "&::-webkit-search-cancel-button": {
      display: "none",
    },
  },
}));

export default useStyles;
